import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '/src/assets/tailwind.css'
/* eslint-disable vue/multi-word-component-names */
import { Icon } from '@iconify/vue2';
/* eslint-disable vue/multi-word-component-names */
Vue.component('Icon', Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
